import React, { useEffect, useRef, useState, useContext } from "react";

import { Context } from "../../provider/index.js";
import languageData from "../../data/language.json";

import "../../styles/animation.css";
import "../../styles/screens/screens.css";

import Header from "./Header";
import Footer from "./Footer";
import Border from "./Border";

const LevelScreen = ({ level }) => {
  const { admin } = useContext(Context);
  const currentLanguage = admin.language;
  const textData = languageData[currentLanguage];

  const m = Math.floor((admin.time / 60) % 60);
  const s = Math.floor(admin.time % 60);

  const seconds = s < 10 ? "0" + s : s;
  const minutes = m < 10 ? "0" + m : m;

  return (
    <div className="uiOverlay">
      <Header />

      <div className="uiField uiFieldBorders">
        <div className="endContainer levelup">
          {level <= 3 ? (
            <div className="levelTextContainer">
              <div className="scoreCont">
                <h2 className="scoreText levelup">
                  {textData.endPageWin.score}
                </h2>
                <h2 className="scoreNumber">
                  {("000000" + admin.score).slice(-6)}
                </h2>
              </div>
              <div className="textWinContainer">
                <h3 className="winText">
                  {textData.explPage.ready}&nbsp;
                  <span className="levelupGanger">
                    <nobr>
                      {textData.explPage.level} {level}
                    </nobr>
                  </span>
                  ?
                </h3>
                {level == 1 && (
                  <button className="btn opt5 levelup">
                    {textData.welcomePage.button}
                  </button>
                )}
              </div>
              <div className="scoreConBottom ">
                <h2 className="timeText levelup">{textData.endPageWin.time}</h2>
                <h2 className="timeNumber">
                  {minutes}:{seconds}
                </h2>
              </div>
            </div>
          ) : (
            <div className="levelTextContainer">
              <div className="scoreCont">
                <h2 className="scoreText levelup">
                  {textData.endPageWin.score}
                </h2>
                <h2 className="scoreNumber">
                  {("000000" + admin.score).slice(-6)}
                </h2>
              </div>
              <div className="textWinContainer">
                <h3 className="winText">
                  {textData.explPage.level} {level}: <br />
                  {textData.levelUpPage.title1}
                  <span className="levelupGanger">
                    {textData.levelUpPage.title2}
                  </span>
                </h3>

                <img
                  src={`./images/gifs/price-${level}.gif`}
                  className="endTitle levelup"
                  alt="you win!"
                ></img>
                <h3
                  className="endScore levelup"
                  dangerouslySetInnerHTML={{
                    __html: textData.levelUpPage.price[level - 3],
                  }}
                />
              </div>
              <div className="scoreConBottom">
                <h2 className="timeText levelup">{textData.endPageWin.time}</h2>
                <h2 className="timeNumber">
                  {minutes}:{seconds}
                </h2>
              </div>
            </div>
          )}
        </div>

        <Border />
      </div>

      <Animation amount={level} />

      <Footer />
    </div>
  );
};

const Animation = ({ amount }) => {
  const container = useRef();
  const [squares, setSquares] = useState([]);

  useEffect(() => {
    const totalSquares = (amount + 2) * (amount + 2) * 10;

    setSquares(Array.from({ length: totalSquares }));

    setTimeout(Animation, 500);
  }, []);

  const Animation = () => {
    let adapted = false;

    if (container.current) {
      container.current.querySelectorAll("div").forEach((el) => {
        const val = parseFloat(el.style.opacity);

        if (val >= 0.2) {
          adapted = true;
        }

        if (Math.random() > 0.66) {
          el.style.opacity = val - 0.2 > 0 ? val - 0.2 : 0;
        }
      });
    }

    if (adapted) {
      setTimeout(Animation, 100);
    }
  };

  return (
    <div className="animationContainer" ref={container}>
      {squares.map((square, index) => (
        <div
          key={index}
          className="square"
          style={{
            opacity: 1,
            backgroundColor: `rgb(255, 0, 0)`,
          }}
        />
      ))}
    </div>
  );
};

export default LevelScreen;
